import type { MyTurfAssignmentDto } from '../types/canvasser'
import type { PlacementFlip } from './offlineStore'

/**
 * [Spec §15.1 D4 / P4-S3] Show a "Visit at home today" person at their HOME stop, today, even before the
 * flip has synced (and keep the "Moved from {worksite}" marker after it has). The household key matches
 * the server's home-key format (`UPPER(street)|zip`, CanvassingService) so a synced and an unsynced flip
 * group into the same stop.
 */
export function applyPlacementFlips(turfs: MyTurfAssignmentDto[], flips: PlacementFlip[]): MyTurfAssignmentDto[] {
  if (flips.length === 0) return turfs
  const byMember = new Map(flips.map(f => [`${f.turfId}|${f.turfMemberId}`, f]))
  return turfs.map(turf => ({
    ...turf,
    contacts: turf.contacts.map(c => {
      const f = byMember.get(`${turf.turfId}|${c.turfMemberId}`)
      if (!f || !c.homeStreetAddress) return c
      return {
        ...c,
        stopLocation: 'Home' as const,
        streetAddress: c.homeStreetAddress,
        city: c.homeCity ?? c.city,
        zip: c.homeZip ?? '',
        latitude: c.homeLatitude,
        longitude: c.homeLongitude,
        householdKey: `${c.homeStreetAddress.toUpperCase()}|${c.homeZip ?? ''}`,
        movedFromWorksite: f.movedFromLabel,
      }
    }),
  }))
}
